import { render, staticRenderFns } from "./RegisterSignUp.vue?vue&type=template&id=a4fb3862&"
import script from "./RegisterSignUp.vue?vue&type=script&lang=js&"
export * from "./RegisterSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports